export const FETCH_RESERVERINGSSYSTEMEN_REQUEST = "FETCH_RESERVERINGSSYSTEMEN_REQUEST";
export const FETCH_RESERVERINGSSYSTEMEN_SUCCESS = "FETCH_RESERVERINGSSYSTEMEN_SUCCESS";
export const FETCH_RESERVERINGSSYSTEMEN_ERROR = "FETCH_RESERVERINGSSYSTEMEN_ERROR";

export const FETCH_RESERVERINGSSYSTEEM_REQUEST = "FETCH_RESERVERINGSSYSTEEM_REQUEST";
export const FETCH_RESERVERINGSSYSTEEM_SUCCESS = "FETCH_RESERVERINGSSYSTEEM_SUCCESS";
export const FETCH_RESERVERINGSSYSTEEM_ERROR = "FETCH_RESERVERINGSSYSTEEM_ERROR";

export const CREATE_RESERVERINGSSYSTEEM_REQUEST = "CREATE_RESERVERINGSSYSTEEM_REQUEST";
export const CREATE_RESERVERINGSSYSTEEM_SUCCESS = "CREATE_RESERVERINGSSYSTEEM_SUCCESS";
export const CREATE_RESERVERINGSSYSTEEM_ERROR = "CREATE_RESERVERINGSSYSTEEM_ERROR";

export const UPDATE_RESERVERINGSSYSTEEM_REQUEST = "UPDATE_RESERVERINGSSYSTEEM_REQUEST";
export const UPDATE_RESERVERINGSSYSTEEM_SUCCESS = "UPDATE_RESERVERINGSSYSTEEM_SUCCESS";
export const UPDATE_RESERVERINGSSYSTEEM_ERROR = "UPDATE_RESERVERINGSSYSTEEM_ERROR";

export const DELETE_RESERVERINGSSYSTEEM_REQUEST = "DELETE_RESERVERINGSSYSTEEM_REQUEST";
export const DELETE_RESERVERINGSSYSTEEM_SUCCESS = "DELETE_RESERVERINGSSYSTEEM_SUCCESS";
export const DELETE_RESERVERINGSSYSTEEM_ERROR = "DELETE_RESERVERINGSSYSTEEM_ERROR";

// Helper functie om responses te verwerken
function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    return response.json().then(err => {
      throw new Error(err.message || response.statusText);
    });
  }
}

// Fetch alle reserveringssystemen
export const fetchReserveringssystemen = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_RESERVERINGSSYSTEMEN_REQUEST });
    
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/admin/reserveringssystemen", {
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FETCH_RESERVERINGSSYSTEMEN_SUCCESS,
        payload: data.results
      });
      
      return { type: "success", data };
    } catch (error) {
      dispatch({
        type: FETCH_RESERVERINGSSYSTEMEN_ERROR,
        payload: error.message
      });
      
      return { type: "error", payload: error.message };
    }
  };
};

// Fetch een specifiek reserveringssysteem
export const fetchReserveringssysteem = (id) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_RESERVERINGSSYSTEEM_REQUEST });
    
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${id}`, {
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: FETCH_RESERVERINGSSYSTEEM_SUCCESS,
        payload: data.result
      });
      
      return { type: "success", data };
    } catch (error) {
      dispatch({
        type: FETCH_RESERVERINGSSYSTEEM_ERROR,
        payload: error.message
      });
      
      return { type: "error", payload: error.message };
    }
  };
};

// Maak nieuw reserveringssysteem aan
export const createReserveringssysteem = (formData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_RESERVERINGSSYSTEEM_REQUEST });
    
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/admin/reserveringssystemen", {
        method: "POST",
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: CREATE_RESERVERINGSSYSTEEM_SUCCESS,
        payload: data.result
      });
      
      return { type: "success", data };
    } catch (error) {
      dispatch({
        type: CREATE_RESERVERINGSSYSTEEM_ERROR,
        payload: error.message
      });
      
      return { type: "error", payload: error.message };
    }
  };
};

// Update bestaand reserveringssysteem
export const updateReserveringssysteem = (id, formData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_RESERVERINGSSYSTEEM_REQUEST });
    
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${id}`, {
        method: "PUT",
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: UPDATE_RESERVERINGSSYSTEEM_SUCCESS,
        payload: { id, data: data.result }
      });
      
      return { type: "success", data };
    } catch (error) {
      dispatch({
        type: UPDATE_RESERVERINGSSYSTEEM_ERROR,
        payload: error.message
      });
      
      return { type: "error", payload: error.message };
    }
  };
};

// Verwijder reserveringssysteem
export const deleteReserveringssysteem = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_RESERVERINGSSYSTEEM_REQUEST });
    
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${id}`, {
        method: "DELETE",
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: DELETE_RESERVERINGSSYSTEEM_SUCCESS,
        payload: id
      });
      
      return { type: "success", data };
    } catch (error) {
      dispatch({
        type: DELETE_RESERVERINGSSYSTEEM_ERROR,
        payload: error.message
      });
      
      return { type: "error", payload: error.message };
    }
  };
};

// Toggle actieve status
export const toggleActiveReserveringssysteem = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${id}/toggle-active`, {
        method: "PATCH",
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      });
      
      const data = await handleResponse(response);
      
      dispatch({
        type: UPDATE_RESERVERINGSSYSTEEM_SUCCESS,
        payload: { id, data: data.result }
      });
      
      return { type: "success", data };
    } catch (error) {
      return { type: "error", payload: error.message };
    }
  };
};

// Test verbinding
export const testConnection = (id) => {
  return async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${id}/test-connection`, {
        method: "POST",
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      });
      
      const data = await handleResponse(response);
      
      return { type: "success", data };
    } catch (error) {
      return { type: "error", payload: error.message };
    }
  };
};

// Import categorieën en locaties
export const importCategoriesAndLocations = (systemId) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${systemId}/import/categories-and-locations`, {
        method: "POST",
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });
      
      const data = await handleResponse(response);
      
      // Return success with detailed message
      let message = data.message;
      if (data.messages && data.messages.length > 0) {
        message += "\n\nDetails:\n" + data.messages.join("\n");
      }
      
      return { type: "success", message, data };
    } catch (error) {
      return { type: "error", payload: error.message };
    }
  };
};

// Import reserveringen
export const importReservations = (systemId) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${systemId}/import/reservations`, {
        method: "POST",
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });
      
      const data = await handleResponse(response);
      
      // Return success with detailed message
      let message = data.message;
      if (data.errorDetails && data.errorDetails.length > 0) {
        message += `\n\nFouten:\n${data.errorDetails.map(err => `- ${err.email}: ${err.error}`).join('\n')}`;
      }
      
      return { type: "success", message, data };
    } catch (error) {
      return { type: "error", payload: error.message };
    }
  };
};

// Haal Tommy artikelen op
export const fetchTommyArtikelen = (systemId) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/admin/reserveringssystemen/${systemId}/tommy/artikelen`, {
        method: 'GET',
        headers: {
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });

      const data = await handleResponse(response);
      
      return { 
        type: "success", 
        data,
        artikelen: data.results || [],
        count: data.results?.length || 0
      };
    } catch (error) {
      return { type: "error", payload: error.message };
    }
  };
};